// import { useState, useEffect } from 'react';
import './Contact.css'
import { useBackground } from '../BackgroundContext';
import Placeholder from './Placeholder';
import { useState, useEffect } from 'react';
import ExpandInput from './ExpandInput'

const Contact = ({ messages, loop=true, defaultText="", pauseTime=1000, finalPauseTime=10000 }) => {
  const { theme } = useBackground();
  const [submitted, setSubmitted] = useState(false);
  const [scrollPosition, setScrollPosition] = useState(0);
    
  useEffect(() => {
    const handleScroll = () => {
      setScrollPosition(window.scrollY); 
    };
    
    window.addEventListener('scroll', handleScroll); 
    return () => window.removeEventListener('scroll', handleScroll); 
  }, []);
  
  // const fontSize = Math.min(2, 0.5 + scrollPosition / 1200) + 'em';

  const namePlaceholder = Placeholder({
    messages: ['John', 'Frank', 'Emily'],
    defaultText: 'Your name',
  });

  const messagePlaceholder = Placeholder({
    messages: ["Hello!", "Coffee?", "How's your day?"],
    defaultText: 'Anything!',
  });

  const emailPlaceholder = Placeholder({
    messages: ['example@gmail.com'],
    defaultText: 'Your email'
  });
  

  const getThemeClass = () => {
    if (theme.background === "#2e2e2e") return "dark-theme-contact";
    if (theme.background === "white") return "light-theme-contact";
    return "light-theme"; // Default
  };

  //send message
  const onSubmit = async (event) => {
    event.preventDefault();
    const form = event.target;
    const formData = new FormData(event.target);

     formData.append("access_key", "2be17cea-996a-45fb-a00c-620aafceb228");

    const object = Object.fromEntries(formData);
    const json = JSON.stringify(object);

    const res = await fetch("https://api.web3forms.com/submit", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json"
      },
      body: json
    }).then((res) => res.json());

    if (res.success) {
      setSubmitted(true)
      console.log("Success", res);
      form.reset(); 
    }
  };

  return (
    <div className={`contact-page ${getThemeClass()}`} id="contact">
      {!submitted ? (
      <form className={`contact-form ${submitted ? 'visible' : ''}`} 
      onSubmit={onSubmit}
      >
        <h2 className="convo">Hi my name is {''} <ExpandInput type="text" className='field' name="name" required placeholder={namePlaceholder}></ExpandInput> 
        and I would like to talk about  
        <ExpandInput type="text" className='field' name="Message" placeholder={messagePlaceholder} required></ExpandInput>
        My email is <ExpandInput type="text" className='field' name="email" placeholder={emailPlaceholder} required></ExpandInput> and I look forward to hearing from you!</h2>

        <div className='submit-form'>
          <button className="submit-button">Submit
          <i className="fa-solid fa-arrow-right"></i>
          </button>
          <div className="linkedin">
            <a href="https://www.linkedin.com/in/nikigeorge/"
            rel="noopener noreferrer"
            target="_blank">
              <i className="fa-brands fa-linkedin"></i>
            </a>
          </div>
        </div>
      </form>
      ) : (
      <h3 className={`thank-you-message ${submitted ? 'visible' : ''}`}>Thank you for your message! 😊</h3>
      )}
        <div className='contact-title'>
            <h1>
                Get in touch
            </h1>
        </div>
    </div>
  );
};

export default Contact;